var GenericErrorCodes;
(function (GenericErrorCodes) {
    GenericErrorCodes["PBERRForbiddenInvalidToken"] = "PBERRForbiddenInvalidToken";
    GenericErrorCodes["PBERRConflict"] = "PBERRConflict";
    GenericErrorCodes["PBERRForbidden"] = "PBERRForbidden";
    GenericErrorCodes["PBERRMaintenance"] = "PBERRMaintenance";
    GenericErrorCodes["PBERRMFARequired"] = "PBERRMFARequired";
    GenericErrorCodes["PBMFASetupRequired"] = "PBLOGMFASetupRequired";
})(GenericErrorCodes || (GenericErrorCodes = {}));
export default GenericErrorCodes;
